import { render, staticRenderFns } from "./VesselsCreate.vue?vue&type=template&id=27246a92&scoped=true&"
import script from "./VesselsCreate.vue?vue&type=script&lang=js&"
export * from "./VesselsCreate.vue?vue&type=script&lang=js&"
import style0 from "./VesselsCreate.vue?vue&type=style&index=0&id=27246a92&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27246a92",
  null
  
)

export default component.exports